import TrendingTags from "@/features/trending/components/TrendingTags";
import { useTrendingTag } from "@/features/trending/hooks/useTrendingTag";

export function TrendingView() {
  const { tags, isLoadingTags, loadTrendingTags, tagsDateRange } =
    useTrendingTag();

  return (
    <div className="flex flex-col items-center justify-center w-full mx-auto space-y-6">
      <TrendingTags
        tags={tags}
        isLoadingTags={isLoadingTags}
        loadTrendingTags={loadTrendingTags}
        tagsDateRange={tagsDateRange}
      />
    </div>
  );
}
